import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useFeedbackTopicStore } from '@/stores/feedback-topic.store'
import type { Skill } from '../models/skill'
import type { QuestionGroup } from '../../modules/give-feedback/models/question-group'
import type { ComplexContent } from '../models/complex-content'
import type { FeedbackTopicType } from '../models/feedback-topic'
import type { JournalTaskFrequency } from '../../modules/coachees/composables/useAddCoacheesWizzard'
import type { Perspective } from '../models/perspective'

export const useCompleteFeedbackTopics = () => {
  const feedbackTopicStore = useFeedbackTopicStore()
  const { templates, loadingStatus } = storeToRefs(feedbackTopicStore)

  onMounted(() => {
    feedbackTopicStore.loadTemplates()
  })

  const data = computed(() => ({
    feedbackTopics: templates.value,
  }))

  return {
    data,
    status: loadingStatus,
  }
}

export interface CompleteFeedbackTopic {
  id: string
  title: string
  type: FeedbackTopicType
  description?: ReadonlyArray<ComplexContent>
  icon?: string
  cta?: string
  duration?: string
  excerpt?: string
  source?: string
  externalLink?: string
  questionGroups: ReadonlyArray<QuestionGroup>
  skills: ReadonlyArray<Skill>
  perspectives: ReadonlyArray<Perspective>
  includeSelf: boolean
  coachOnly?: boolean
  defaults?: {
    isActive?: boolean
    amount?: number
    frequency?: JournalTaskFrequency
    numberOfSelfFeedbacks?: number
    numberOfPeerFeedbacks?: number
    numberOfExternalFeedbacks?: number
  }
}
